<template>
  <div>
    <custom-toolbar
      :title="'Détails de l\'opérateur'"
      @refresh="refreshObjet"
    />
    <v-row class="mt-1">
      <v-col
        cols="12"
        lg="4"
        md="5"
      >
        <v-skeleton-loader
          v-show="isDialogVisible"
          boilerplate
          class="mx-auto"
          elevation="2"
          max-width="360"
          type="card-avatar, article, article, actions"
        ></v-skeleton-loader>
        <operator-panel v-show="!isDialogVisible" />
      </v-col>
      <v-col
        cols="12"
        lg="8"
        md="8"
      >
        <v-skeleton-loader
          v-show="isDialogVisible"
          boilerplate
          class="mx-auto"
          elevation="2"
          max-width="840"
          type="table-heading,divider, image, article, article, actions"
        ></v-skeleton-loader>
        <v-tabs
          v-show="!isDialogVisible"
          v-model="operatorTab"
          show-arrows
          class="operator-tabs"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>
        </v-tabs>
        <v-tabs-items
          v-show="!isDialogVisible"
          id="operator-tabs-content"
          v-model="operatorTab"
          class="mt-5 pa-1"
        >
          <v-tab-item>
            <operator-api-list />
          </v-tab-item>
          <v-tab-item>
            <operator-api-product-list :operator="operator" />
          </v-tab-item>
          <v-tab-item>
            <operator-api-token-list />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getCurrentInstance, onMounted, ref } from '@vue/composition-api'
import {
  mdiArrowLeftBoldCircleOutline,
  mdiRefresh,
  mdiTwoFactorAuthentication,
  mdiOffer,
  mdiApi,
} from '@mdi/js'
import OperatorPanel from '@core/components/operator/OperatorPanel'
import LoaderDialog from '@core/components/dialogs/LoaderDialog'
import OperatorApiList from '@core/components/operator/OperatorApiList'
import OperatorApiProductList from '@core/components/operator/OperatorApiProductList'
import OperatorApiTokenList from '@core/components/operator/OperatorApiTokenList'
import store from '@/store'
import router from '@/router'
import CustomToolbar from "@core/components/toolbar/CustomToolbar";

export default {
  name: 'OperatorDetails',
  components: {
    CustomToolbar,
    OperatorApiTokenList,
    OperatorApiProductList,
    OperatorApiList,
    OperatorPanel,
    LoaderDialog,
  },
  computed: {
    ...mapState('operator', ['operator']),
  },

  setup() {
    const isDialogVisible = ref(false)
    const operatorTab = ref(null)
    // eslint-disable-next-line no-shadow,no-use-before-define
    const route = getCurrentInstance().proxy.$route

    const getItem = () => {
      const id = route.params.id !== undefined ? route.params.id : null
      if (id !== null) {
        store.dispatch('api/setOpId', id)
        if (store.state.operator.operator === null || store.state.operator.operator.id !== id) {
          isDialogVisible.value = true
          store.dispatch('operator/getOperatorById', id).then(() => {
            isDialogVisible.value = false
          }).catch(error => {
            console.log(error)
          })
        }
      }
    }

    const refreshObjet = () => {
      const id = route.params.id !== undefined ? route.params.id : null
      if (id !== null) {
        isDialogVisible.value = true
        store.dispatch('operator/getOperatorById', id).then(() => {
          isDialogVisible.value = false
        }).catch(error => {
          console.log(error)
        })
      }
    }

    onMounted(getItem)

    const prev = () => {
      router.back()
    }

    const tabs = [
      { icon: mdiApi, title: 'API' },
      { icon: mdiOffer, title: 'PRODUITS' },
      { icon: mdiTwoFactorAuthentication, title: 'TOKENS' },
    ]

    return {
      isDialogVisible,
      getItem,
      prev,
      refreshObjet,
      tabs,
      operatorTab,
      icons: {
        mdiRefresh,
        mdiArrowLeftBoldCircleOutline,
        mdiTwoFactorAuthentication,
        mdiOffer,
        mdiApi,
      },
    }
  },
}
</script>

<style scoped>

</style>
